import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { Models } from '@ibexfusion/models';
import { GroupHasRoleInOrganisationService } from '@services/groups/group-has-role-in-organisation.service';
import { GroupService } from '@services/groups/group.service';
import { DynamicContentService } from '@services/dynamic-content/dynamic-content.service';
import { DynamicContentEntranceService } from '@services/dynamic-content/dynamic-content-entrance.service';
import { PackageInstalledAppsService } from '@services/packages/package-installed-apps.service';
import { MessengerService } from '@services/messenger/messenger.service';
import { GroupHasFrontProfileService } from '@services/groups/group-has-frontprofile.service';
import { FrontProfilesService } from '@services/front-profiles/front-profiles.service';

@Component({
  selector: 'notification-statistics',
  providers: [GroupService, GroupHasRoleInOrganisationService, DynamicContentEntranceService, DynamicContentService, PackageInstalledAppsService, FrontProfilesService, GroupHasFrontProfileService],
  templateUrl: './notification-statistics.component.html',
  styleUrl: './notification-statistics.component.scss',
  standalone: false
})
export class NotificationStatisticsComponent implements OnChanges {
  @Input() notification: Models.Notification;
  @Input() pak: Models.Package;
  @Input() packageId: string;
  @Output() close = new EventEmitter<any>();

  public notificationId: string;
  public groups: Models.Group[];
  public activeGroups: any[];
  public ghrio: Models.GroupHasRoleInOrganisation[];
  public dynamicContent: Models.DynamicContent;
  public app: any;
  public contentTitle: string;
  public receivers: any[];

  constructor(
    private ghrioService: GroupHasRoleInOrganisationService, private groupService: GroupService, private contentService: DynamicContentService,
    private ms: MessengerService, private entranceService: DynamicContentEntranceService, private appService: PackageInstalledAppsService,
    private ghfpService: GroupHasFrontProfileService, private profileService: FrontProfilesService
  ) {}

  async ngOnChanges() {
    this.notificationId = this.notification._id;
    if (this.notification?.contentId) {
      this.setContent(this.notification.contentId);
    }

    this.ghrio = (await this.ghrioService.find(0, 1000, { OrganisationID: this.ms.getOrganisation().OrganisationID, GroupID: { $ne: 8 } })).data;
    this.groups = (await this.groupService.find(0, this.ghrio.length, {
      GroupID: { $in: this.ghrio.filter(el => [45, 49, 53, 55].includes(parseInt(el.RoleID, 10))).map(el => el.GroupID) }
    })).data;
    this.activeGroups = this.groups.filter(g => (this.notification?.groupIds || []).includes(g.GroupID.toString()));
    for (let i = 0; i < this.activeGroups.length; i++) {
      const profileCount = await this.ghfpService.find(0, 1000, { GroupID: this.activeGroups[i].GroupID });
      this.activeGroups[i].description = profileCount.data.length;
    }
    if (this.notification.groupIds?.length) {
      this.receivers = (await this.ghfpService.find(0, 1000, { GroupID: { $in: this.notification.groupIds } })).data;
    } else {
      const params = this.pak?.ibexApp?.notificationsOnlyForRegistered ? { packageId: this.packageId, isAnonymous: 0 } : { packageId: this.packageId };
      this.receivers = (await this.profileService.find(0, 10000, params)).data;
    }
  }

  async setContent(id: string) {
    delete this.contentTitle;
    this.dynamicContent = await this.contentService.get(id);
    const parentChain = [this.dynamicContent];
    let parent = (await this.contentService.find(0, 1, { children: parentChain[0]._id }))?.data?.[0];
    while (parent) {
      parentChain.unshift(parent);
      parent = (await this.contentService.find(0, 1, { children: parentChain[0]._id }))?.data?.[0];
    }
    const entrance = (await this.entranceService.find(0, 1, { children: parentChain[0]._id }))?.data?.[0];
    this.app = (await this.appService.find(0, 1, { dynamicContentEntranceId: entrance?._id }))?.data?.[0];
    this.contentTitle = [this.app?.translations?.[0]?.appTitle].concat(parentChain.map(p => p.title)).join('/');
    this.notification.contentId = id;
  }

  public getDate(notification: any, planned = false) {
    if (planned && notification.instant) {
      return 'sofort';
    }
    let d: any = new Date(planned ? notification.publishStart : notification.sent);
    const options: any = { weekday: 'short', day: '2-digit', month: '2-digit', year: 'numeric' };
    const format = new Intl.DateTimeFormat('de-DE', planned ? options : { ...options, hour: '2-digit', minute: '2-digit', hour12: false });
    return (format.format(d).replace(/,/, '').replace(/\s*Uhr\s*$/i, '') + `${planned ? ' ' + notification.publishStartTime : ''}`).replace('.', ',');
  }

  getGroupTitle(val) {
    return (val || '').startsWith('pref_') ? val.split('_').splice(2, val.split('_').length - 1).join('_') : val;
  }
}
